import { contemTextoPesquisa } from "../Utils/pesquisaTexto";
import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { collection, getDocs } from "firebase/firestore";
import { useHistory } from "react-router-dom";
import Navbar from "../Components/Navbar/navbar";
import HistoricoCadastro from "../Components/HistoricoCadastro/HistoricoCadastro";
import { db } from "../Config/firebase";
import { consultaTenantAtual } from "../Utils/tenant";

function dataBR(valor) {
  if (!valor) return "-";
  const [ano, mes, dia] = String(valor).split("-");
  return ano && mes && dia ? `${dia}/${mes}/${ano}` : valor;
}

function moeda(valor) {
  const numero = Number(valor || 0);
  return numero.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
}

export default function ListaMedicoes() {
  const history = useHistory();
  const [medicoes, setMedicoes] = useState([]);
  const [filtro, setFiltro] = useState("");
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    async function carregar() {
      try {
        const snap = await getDocs(consultaTenantAtual(collection(db, "tblMedicoes")));
        setMedicoes(
          snap.docs
            .map((item) => ({ id: item.id, ...item.data() }))
            .sort((a, b) => {
              const porData = String(b.data || "").localeCompare(String(a.data || ""));
              return porData || String(b.codigo || "").localeCompare(String(a.codigo || ""), "pt-BR", { numeric: true });
            })
        );
      } catch (error) {
        console.error("Erro ao carregar medições:", error);
      } finally {
        setCarregando(false);
      }
    }
    carregar();
  }, []);

  const lista = useMemo(() => {
    const termo = filtro.trim().toLocaleLowerCase("pt-BR");
    if (!termo) return medicoes;
    return medicoes.filter((item) =>
      [item.codigo, item.cliente, item.obra, item.data]
        .some((valor) => contemTextoPesquisa(String(valor || "").toLocaleLowerCase("pt-BR"), termo))
    );
  }, [medicoes, filtro]);

  return (
    <>
      <Navbar />
      <Box sx={{ p: { xs: 2, md: 4 } }}>
        <Paper className="cabecalho-lista-cadastro" elevation={0}>
        <Typography variant="h6" fontWeight={700}>Medições</Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>Planilhas de medição de serviços</Typography>
        <Stack direction={{ xs: "column", md: "row" }} spacing={2} mb={3}>
          <Button variant="contained" startIcon={<AddIcon />} onClick={() => history.push("/app/medicoes/novo")}>
            Nova medição
          </Button>
          <TextField
            size="small"
            label="Pesquisar por código, cliente, obra ou data"
            value={filtro}
            onChange={(event) => setFiltro(event.target.value)}
            sx={{ flex: 1 }}
          />
        </Stack>
        </Paper>

        <Paper variant="outlined">
          <TableContainer>
            <Table className="lista-cadastro-padrao" size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Código</TableCell>
                  <TableCell>Data</TableCell>
                  <TableCell>Cliente / Obra</TableCell>
                  <TableCell align="right">Valor total</TableCell>
                  <TableCell align="center">Ações</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {lista.map((item) => (
                  <TableRow
                    hover
                    key={item.id}
                    sx={{ cursor: "pointer" }}
                    onClick={() => history.push(`/app/medicoes/${item.id}`)}
                  >
                    <TableCell>{item.codigo || "-"}</TableCell>
                    <TableCell className="lista-dado-secundario">{dataBR(item.data)}</TableCell>
                    <TableCell>
                      <div className="lista-dado-principal">{item.cliente || "-"}</div>
                      <div className="lista-dado-secundario">Obra: {item.obra || "-"}</div>
                    </TableCell>
                    <TableCell className="lista-dado-destaque" align="right">{moeda(item.totalGeral)}</TableCell>
                    <TableCell align="center">
                      <Tooltip title="Visualizar relatório">
                        <IconButton
                          size="small"
                          onClick={(event) => {
                            event.stopPropagation();
                            history.push(`/app/medicoes/${item.id}?relatorio=true&origem=lista`);
                          }}
                        >
                          <VisibilityIcon color="primary" />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Editar cadastro">
                        <IconButton
                          size="small"
                          onClick={(event) => {
                            event.stopPropagation();
                            history.push(`/app/medicoes/${item.id}`);
                          }}
                        >
                          <EditIcon color="primary" />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Clonar medição">
                        <IconButton
                          size="small"
                          onClick={(event) => {
                            event.stopPropagation();
                            history.push(`/app/medicoes/novo?clonar=${encodeURIComponent(item.id)}`);
                          }}
                        >
                          <ContentCopyIcon sx={{ color: "#0288d1" }} />
                        </IconButton>
                      </Tooltip>
                      <span onClick={(event) => event.stopPropagation()}>
                        <HistoricoCadastro colecao="tblMedicoes" documentoId={item.id} registro={item} />
                      </span>
                    </TableCell>
                  </TableRow>
                ))}
                {carregando && (
                  <TableRow><TableCell colSpan={5} align="center"><CircularProgress size={24} /></TableCell></TableRow>
                )}
                {!carregando && !lista.length && (
                  <TableRow><TableCell colSpan={5} align="center">Nenhuma medição cadastrada.</TableCell></TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </Box>
    </>
  );
}
